module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ../~/css-animation/~/babel-runtime/core-js/symbol/iterator.js
 ** module id = 1339
 ** module chunks = 3
 **/